import React from 'react';
import times from 'lodash/times';
import classNames from 'classnames';
import styles from './Row.module.scss';

interface Props {
  data?: any; // TODO: add type
  columns?: any[]; // TODO: add type
  columnCount: number;
  isLoading?: boolean;
  className?: string;
}

const Row = ({ data, columns, columnCount, isLoading, className }: Props) => (
  <div
    className={classNames(styles.Row, className)}
    style={{ gridTemplateColumns: `repeat(${columnCount}, 1fr)` }}
  >
    {isLoading ? (
      times(columnCount).map((column) => (
        <div key={column} className={styles.column}>
          <span className={styles.animatedBg} />
        </div>
      ))
    ) : (
      <>
        {(columns || []).map((column, index) => {
          return (
            column.isVisible && (
              <div key={index} className={styles.column}>
                <span dangerouslySetInnerHTML={{ __html: data[column.key] }} />
              </div>
            )
          );
        })}
      </>
    )}
  </div>
);

export default Row;
